<template>
    <div
        class="award-booking-program col-span-12 md:col-span-6 lg:col-span-4 mb-5 relative overflow-visible rounded-lg bg-white dark:bg-slate-800 px-4 pt-5 pb-12 shadow dark:shadow-slate-900/50 sm:px-6 sm:pt-6 border border-gray-200 dark:border-slate-700 flex flex-col"
    >
        <div class="flex flex-col justify-between h-full">
            <div class="card-body">
                <h5 class="font-bold text-xl mb-2 program-title text-slate-800 dark:text-slate-100">
                    Need help using your points?
                </h5>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-300 mb-2 program-text">
                    Let one of our expert award bookers help you book your trip
                </p>
            </div>
        </div>
        <div
            class="flex w-full items-end justify-between px-2 absolute inset-x-0 bottom-0 px-6 py-4"
        >
            <a
                href="https://10xtravel.com/award-booking/?utm_source=my10x&utm_medium=banner&utm_campaign=mypointspromo"
                target="_blank"
                class="btn-base btn-dark dark:bg-slate-700 dark:hover:bg-slate-600 btn btn-primary btn-orange"
                id="hs-mypoints-award-booking-btn"
            >
                Book Now
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.award-booking-program {
    background-image: url('@@/images/program_images/award-booking-program-sky-clouds-overlay.png'),
        url('@@/images/program_images/award-booking-program-airplane-lg.png'),
        url('@@/images/program_images/award-booking-program-vast-sky-with-fluffy-white-clouds.png');
    background-size: contain, contain, cover;
    background-position:
        bottom -10vh right,
        center right,
        center;
    background-repeat: no-repeat, no-repeat, no-repeat;
    min-height: 216px;

    & .card-header {
        max-width: 200px;
    }

    & .card-body {
        grow: 1;
        max-width: 75%;
    }

    h5 {
        font-size: 2rem;
    }

    p {
        font-size: 1.125rem;
    }
}

.loyalty-programs .award-booking-program {
    background-position:
        bottom -3.5vh right,
        center right -12vw,
        center;
    h5 {
        font-size: 1.25rem;
    }
    p {
        font-size: 0.875rem;
    }
}

.btn-orange {
    margin-left: 0 !important;
}
</style>
